"use strict";

/**
 * Sidebae should handle
 * - 'module' navigation
 */

class AppSidebarCtrl {

    constructor($rootScope, $scope, $mdToast, $state, $http, $cookies, bladesManager, disableMenu, $transitions) {

        this.$mdToast = $mdToast;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$http = $http;
        this.$cookies = $cookies;
        this.bladesManager = bladesManager;
        this.disableMenuItems = false;
        this.activeMenu = null;

        this.menuItems = [];
        this.loadMenu();
        $scope.$on('applicationsSaved', () => {
            this.loadMenu();
        });

        this.unfold = $cookies.get('unfold') != 'false';
        this.$rootScope.unfold = this.unfold;

        $scope.$on('changeMenuState', function() {
            $scope.disableMenuItems = disableMenu.state;
        });

        let unRegisterSetActiveListener = $transitions.onSuccess({ }, () => {
            let parentState = this.$state.current.name.split('.')[0];
            let widgetId = this.$state.params.widgetId;

            if(this.$state.current.name == 'rundown.live') {
                parentState = 'live';
            }

            this.setActive(parentState, widgetId); //always use the parent state for activeMenuItem, except for live rundown
        });

        $scope.$on('$destroy', () => {
            unRegisterSetActiveListener();
        })
    };

    loadMenu() {
        this.$http.get('/dashboard/menu').then((response) => {
            this.menuItems = response.data;
        });
    }

    setActive(menuItem, widgetId) {
        this.activeMenu = menuItem;
        this.activeWidget = widgetId;
    }

    toggleSidenav() {

        let now = new Date();

        // this will set the expiration to 12 months
        let exp = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());

        this.unfold = !this.unfold;
        this.$cookies.put('unfold', this.unfold, {'expires': exp});
        this.$rootScope.unfold = this.unfold;
    };

    go(url, params) {

        if(url == 'live') {
            url = 'rundown.live';
        }

        this.$state.go(url, params);
    };
}

AppSidebarCtrl.$inject = ['$rootScope', '$scope', '$mdToast', '$state', '$http', '$cookies', 'bladesManager', 'disableMenu', '$transitions'];

module.exports = AppSidebarCtrl;
